var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4698 21.1191C16.4698 21.1191 8.57419 21.1182 8.54403 21.1182C6.4716 21.0724 4.82825 19.3551 4.87398 17.2827V6.7756C4.92263 4.73625 6.59419 3.11042 8.63451 3.11918H14.2855C14.844 3.11918 15.3782 3.34588 15.7644 3.74869L19.5561 7.69798C19.9219 8.08036 20.1272 8.58922 20.1272 9.11754V10.5M20.1272 13.5V17.2827C20.1409 19.3376 18.5238 21.0355 16.4698 21.1191H8.63451C8.60435 21.1191 8.57419 21.1182 8.54403 21.1182",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7695 3.18164V6.07428C14.7686 7.48606 15.9118 8.63125 17.3236 8.63417H20.0625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0242C16 12.0914 14.4331 10.5242 12.5 10.5242C10.5669 10.5242 9 12.0914 9 14.0242C9 15.9573 10.5669 17.5242 12.5 17.5242C14.4331 17.5242 16 15.9573 16 14.0242Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V13.6776C12 13.8556 12.1444 14 12.3224 14H15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavReports);
export default __webpack_public_path__ + "static/media/icon-nav-reports.7ef8b7d1f3237e2f83ff594eef1c6a61.svg";
export { ForwardRef as ReactComponent };